import { render } from "./AddNewVendorGroup.vue?vue&type=template&id=233de481"
import script from "./AddNewVendorGroup.vue?vue&type=script&lang=js"
export * from "./AddNewVendorGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__